<template lang="html">
  <section class="app-update-project">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the award you would like to update.
    </p>
    <form v-else @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="projectType" class="w-25 align-self-center">* Type :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectType.$error ? 'is-invalid': ''" type="text"
                 @blur="$v.dataForm.projectType.$touch() || (dataForm.projectType = (dataForm.projectType === '') ? savedData.type : dataForm.projectType)"
                 v-model="dataForm.projectType"
                 class="form-control" id="projectType">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectType.required">
              You must absolutely enter a project type !
            </div>
            <div v-if="!$v.dataForm.projectType.minLength">
              Work type must not have less than {{$v.dataForm.projectType.$params.minLength.min}} characters !
            </div>
            <div v-if="!$v.dataForm.projectType.maxLength">
              Work type must not contain more than {{$v.dataForm.projectType.$params.maxLength.max}} characters !
            </div>
            <div v-if="!$v.dataForm.projectType.alphaNum">You can't enter special characters !</div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
import {FORM_PROJECTS_TYPES_VALIDATIONS} from '../../validations/formProjectsTypes'
export default {
  name: 'UpdateProjectsType',
  props: [],
  mounted () {},
  created () {
    this.readOneData()
      .then(data => {
        this.savedData = data;
        this.dataForm.projectType = this.savedData.type;
      })
      .catch()
  },
  validations: FORM_PROJECTS_TYPES_VALIDATIONS,
  data () {
    return {
      savedData : null,
      dataForm : {
        projectType: undefined
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setCrudComponent',
      'readOneData',
      'updateData'
    ]),
    navigateAway(tab) {
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    },
    onSubmit () {
      const formData = {
        project_type_id : (this.getCurrentElement) ? this.getCurrentElement.id : '',
        type: this.dataForm.projectType
      };
      this.updateData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => this.messageSubmission = '', 5000);
        })
        .catch()
    },
    resetForm () {
      this.dataForm.projectType = this.savedData.type;
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getCurrentElement'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-update-project {}
</style>



// WEBPACK FOOTER //
// src/components/projects_types/UpdateProjectsType.vue